import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ReferenceIdRowProps {
  correlationId: string;
  className?: string;
}

const ReferenceIdRow = ({ correlationId, className }: ReferenceIdRowProps) => {
  return (
    <div
      className={twMerge(
        'mt-3 w-full rounded-lg border border-neutral-200 bg-neutral-50 p-3 text-left',
        className,
      )}
      data-testid="reference-id-row"
    >
      <p className="text-xs font-medium text-neutral-500">Reference ID</p>
      <div className="mt-1 flex items-center gap-2">
        <code className="flex-1 break-all text-xs text-neutral-800">
          {correlationId}
        </code>
        <button
          type="button"
          onClick={() => {
            void navigator.clipboard.writeText(correlationId);
          }}
          className="shrink-0 rounded border border-neutral-300 bg-white px-2 py-1 text-xs font-semibold text-neutral-700 hover:bg-neutral-100"
        >
          Copy
        </button>
      </div>
    </div>
  );
};

export default ReferenceIdRow;
